import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { retrieveGetShopServices } from '../redux/slice/getShopSlice';
import ProductCard from '../Components/ProductCard';
import bgImg from '../Assets/header_bg/shop_bg.png';
import WhatsApp from '../Components/WhatsApp';
import ProgressBar from '../../components/progress/ProgressBar';

const ShopPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [productPerPage] = useState(12);

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo(0, 0);
  }, [currentPage]);
  //
  const dispatch = useDispatch();
  const cachedData = useSelector((state) => state.shop);
  const data = React.useMemo(() => cachedData, [cachedData]);
  const initFetch = React.useCallback(() => {
    dispatch(retrieveGetShopServices());
  }, [dispatch]);

  React.useEffect(() => {
    initFetch();
  }, [initFetch]);

  //
  const totalProducts = data?.data?.length; // Total number of products
  const totalPages = Math.ceil(totalProducts / productPerPage); // Calculate total pages
  const indexOfLastPost = currentPage * productPerPage;
  const indexOfFirstPost = indexOfLastPost - productPerPage;
  const currentPosts =
    !data?.data || data?.data.length === 0 ? [] : data?.data?.slice(indexOfFirstPost, indexOfLastPost);

  return (
    <Grid container className="top-container" justifyContent={'center'}>
      <Helmet>
        <title>Art Print & Stationery | PakPrint Wishes</title>
        <meta
          name="description"
          content="We are an online printing company in Pakistan that provides all type of printing services. Print with Pak Print Wishes and make your brand shine!"
        />
        <meta property="og:title" content="Art Print & Stationery | PakPrint Wishes" />
        <meta
          property="og:description"
          content="We are an online printing company in Pakistan that provides all type of printing services. Print with Pak Print Wishes and make your brand shine!"
        />
        <meta property="og:image" content={bgImg} />
        <meta property="og:type" content="website" />
        <meta property="og:image:width" content="100%" />
        <meta property="og:url" content={window.location.href} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <WhatsApp />
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        className="featured-products-header"
        sx={{ backgroundImage: `url(${bgImg})` }}
      >
        <Grid container justifyContent={'center'}>
          <Grid item xs={12} sm={12} md={12} lg={9} xl={9} sx={{ display: 'flex' }}>
            <div className="breadcrumb-text">
              <h1 className="breadcrumb-text__title">Art Print & Stationery</h1>
              <ul className="breadcrumb-text__nav">
                <li>
                  <Link to={'/'}>Home</Link>
                </li>
                <li>&nbsp;-&nbsp;</li>
                <li>Art Print & Stationery</li>
              </ul>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid py={6} item xs={12} sm={12} md={12} lg={11} xl={11}>
        {data?.loading && <ProgressBar />}
        <Grid container spacing={2} className="featured-products-container">
          {currentPosts?.map((image, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={index}>
              <ProductCard image={image} />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="pagination-container">
        <Pagination
          count={totalPages} // Show total pages instead of current page
          page={currentPage} // Set the current page
          renderItem={(item) => (
            <PaginationItem components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }} {...item} />
          )}
          variant="outlined"
          shape="rounded"
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
};

export default ShopPage;
